import { forwardRef } from "react";
import { IconoCargando } from "./Iconos";
import "./kit.css";

/* ============================================================================
   BOTÓN · la única implementación del sistema.
   Sustituye a los cuatro mecanismos que conviven hoy (antd, react-bootstrap,
   `<button>` suelto y las 12 variantes de clase del tema).

   Reglas del sistema, cumplidas aquí:
   · Un solo primario por pantalla -- se decide en la pantalla, pero el
     componente hace que el primario se note.
   · El texto dice la acción concreta. `titulo` obligatorio para el modo icono,
     porque un botón sin texto necesita nombre accesible.
   · En acciones destructivas el rojo va en el PRIMARIO: `variante="destructivo"`
     pinta el botón rojo; nunca hay un secundario rojo.

   Anatomía literal de la referencia: 34px por defecto (30 / 38 los otros
   tamaños), radio 7px, padding 0 14px, fuente 13px/500, gap 7px.
   ========================================================================== */

export const VARIANTES = ["primario", "secundario", "ghost", "destructivo"];
export const TAMANOS = { sm: "kb--sm", md: "", lg: "kb--lg" };

const Boton = forwardRef(function Boton(
    {
        children,
    variante = "secundario",
    tamano = "md",
    icono: Icono,
    soloIcono = false,
    titulo,
    cargando = false,
    disabled = false,
    type = "button",
        className = "",
        ...resto
    },
    ref
) {
    const varianteSegura = VARIANTES.includes(variante) ? variante : "secundario";
    const clases = [
        "kb",
        `kb--${varianteSegura}`,
        TAMANOS[tamano] || "",
        soloIcono ? "kb--icono" : "",
        cargando ? "kb--cargando" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const tamanoIcono = tamano === "lg" ? 17 : 16;

    return (
        <button
            ref={ref}
            type={type}
            className={clases}
            disabled={disabled || cargando}
            aria-busy={cargando || undefined}
            aria-label={soloIcono ? titulo : undefined}
            title={titulo}
            {...resto}
        >
            {cargando ? (
                <IconoCargando size={15} className="kb__girar" />
            ) : (
                Icono && <Icono size={tamanoIcono} />
            )}
            {!soloIcono && children}
        </button>
    );
});

export default Boton;
